import { SVGFC } from '@repo/toolkit/types'

const GermanIcon: SVGFC = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21066_833949)">
        <path
          d="M4.15308 17.6513C5.63665 21.6497 9.48535 24.4991 14 24.4991C18.5146 24.4991 22.3633 21.6497 23.8469 17.6513L14 16.7383L4.15308 17.6513Z"
          fill="#FFDA44"
        />
        <path
          d="M14 3.5C9.48535 3.5 5.63665 6.34944 4.15308 10.3478L14 11.2609L23.8469 10.3478C22.3633 6.34944 18.5146 3.5 14 3.5Z"
          fill="black"
        />
        <path
          d="M4.15309 10.3477C3.73104 11.4851 3.5 12.7154 3.5 13.9998C3.5 15.2842 3.73104 16.5145 4.15309 17.652H23.847C24.269 16.5145 24.5 15.2842 24.5 13.9998C24.5 12.7154 24.269 11.4851 23.8469 10.3477H4.15309Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_21066_833949">
          <rect width="21" height="21" fill="white" transform="translate(3.5 3.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GermanIcon
